import api from '../api.js';

export function getAnalyticsOverview(params = {}) {
  return api.get('/analytics/overview', { params });
}

export function getAnalyticsByLand(params) {
  return api.get('/analytics/by-land', { params });
}

export function getAnalyticsByCrop(params) {
  return api.get('/analytics/by-crop', { params });
}

export function getAnalyticsByFieldWork(params) {
  return api.get('/analytics/by-field-work', { params });
}
